/**
 * THE WORKFLOW FIELD IS DEPRECATED
 */

/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import DelayedLoadSelector from '../components/DelayedLoadSelector';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import * as WorkflowsActions from 'ContentData/actions/Workflows';
import { getWorkflowsOptions } from 'ContentData/selectors/workflows';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.workflow.${key}`;
const mapStateToProps = state => {
  return {
    options: getWorkflowsOptions(state) || []
  };
};
const mapDispatchToProps = {
  fetchWorkflow: WorkflowsActions.fetchWorkflow
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class WorkflowSelect extends Component {
  constructor(props) {
    super(props);
    this.onClearWorkflow = this.onClearWorkflow.bind(this);
  }
  componentDidMount() {
    if (this.props.value) {
      this.props.fetchWorkflow(this.props.value);
    }
  }
  onClearWorkflow() {
    this.props.onFieldChange(null);
  }
  renderIsDeprecatedAlert() {
    const {
      value
    } = this.props;
    return /*#__PURE__*/_jsx(UIAlert, {
      className: "m-bottom-2",
      "data-selenium": "workflow-field-deprecated-alert",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('deprecatedAlert.titleText')
      }),
      type: "warning",
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: i18nKey('deprecatedAlert.message_jsx'),
          elements: {
            Link: UILink
          },
          options: {
            href: 'https://community.hubspot.com/t5/Blog-Website-Page-Publishing/New-workflow-attach-functionality/m-p/466547#M5146'
          }
        }), value && /*#__PURE__*/_jsx(UIButton, {
          onClick: this.onClearWorkflow,
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('deprecatedAlert.clearWorkflowButton')
          })
        })]
      })
    });
  }
  render() {
    const {
      value
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderIsDeprecatedAlert(), value && /*#__PURE__*/_jsx(DelayedLoadSelector, Object.assign({}, this.props, {
        disabled: true,
        loadOptions: () => {}
      }))]
    });
  }
}
export default connector(WorkflowSelect);